
































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DemoServer from "../../shared/DemoServer";
import DateFormatter from "../../shared/DateFormatter";
import OverlayWindow from "../general/OverlayWindow.vue";
import Loading from "../general/Loading.vue";

import HolidayProgramJson, { HolidayProgramWithBookingsJson } from "../../shared/HolidayProgramJson";
import HolidayProgramBookingJson, { defaultHolidayProgramBookingJson } from "../../shared/HolidayProgramBookingJson";
import { HolidayProgramBookingStatus } from "../../shared/HolidayProgramBookingStatus";

import { UserPermissionRank } from "../../shared/UserPermissionRank";
import { Gender } from "../../shared/Gender";

import { validateHolidayProgramBookingJson } from "../../shared/HolidayProgramBookingJson";
import { validateHolidayProgramBookingJsonAddNew } from "../../shared/HolidayProgramBookingJson";
import { ValidationResult, Validation } from "../../shared/Validation";

import CustomerJson, { defaultCustomerJson } from "../../shared/CustomerJson";
import SepaMandateJson from "../../shared/SepaMandateJson";
import HolidayProgramPriceJson from "../../shared/HolidayProgramPriceJson";

import InvoiceInfoDetails from "../general/InvoiceInfoDetails.vue";

type keysForCachedPrices = {
  [key in keyof Pick<HolidayProgramBookingJson, "price" | "cancellationFee">]: string;
};

export default Vue.extend({
  name: "HolidaysBookingDetails",
  components: {
    OverlayWindow,
    Loading,
    InvoiceInfoDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    selectedProgramId: Number,
    selectedBookingId: Number,
    HolidayProgramBookingStatusNames: Object,
    mode: String,
  },
  data() {
    return {
      DemoServer: DemoServer,
      DateFormatter: DateFormatter,
      supportsDatePicker: false,
      editable: false as boolean,
      detailsTitle: "",
      UserPermissionRank: UserPermissionRank,
      Gender: Gender,
      genderNames: {
        male: "männlich",
        female: "weiblich",
        other: "divers",
      },
      HolidayProgramBookingStatus: HolidayProgramBookingStatus,
      detailsMode: "",
      programTitle: "" as string,
      programDetails: null as HolidayProgramJson | null,
      programDetailsWithBookings: null as HolidayProgramWithBookingsJson | null,
      programBookingDetails: null as HolidayProgramBookingJson | null,
      cachedPrices: {
        price: "0,00",
        cancellationFee: "0,00",
      } as keysForCachedPrices,
      cachedCustomerGuardian: { addressCountry: "Deutschland" } as Pick<
        CustomerJson,
        | "guardianFirstName"
        | "guardianLastName"
        | "email"
        | "phone"
        | "addressStreet"
        | "addressZip"
        | "addressCity"
        | "addressCountry"
      >,
      cachedCustomersBirthDates: [] as string[],
      selectedPrice: null as HolidayProgramPriceJson | null,
      selectedExtras: null as HolidayProgramPriceJson[] | null,
      useSepaMandate: false as boolean,
      showEmployerInputs: false as boolean,
      hasChanges: false,
      hintChanged: {
        selectedDiscount: false as boolean,
        selectedExtras: false as boolean,
      },
      frontendValidations: {
        minimumAge: false,
        maximumAge: false,
        requiresAllGuardiansEmployed: false,
        neededIsSingleParent: false,
        minimumClass: false,
        maximumClass: false,
        requiresEmployerInputs: false,
      },
      toValidate: {} as any,
      validation: null as ValidationResult<HolidayProgramBookingJson> | null,
      submitValidation: false as boolean,
      loadingGeneral: false as boolean,
      loadingNextup: false as boolean,
    };
  },
  created() {
    this.initHolidaysBookingDetails();
  },
  mounted() {
    this.checkDatePickerSupport();
    this.setCachedCustomersBirthDates();
  },
  methods: {
    initHolidaysBookingDetails() {
      this.loadProgramDetails();
      this.loadProgramBookingDetails();
    },

    checkDatePickerSupport() {
      let testvalue = "a";
      var ele = <HTMLInputElement>this.$refs["testDatePicker"];

      if (ele != null) {
        ele.value = testvalue;

        if (ele.value !== testvalue) {
          this.supportsDatePicker = true;
        }
      }
    },

    /* async loadProgramDetails() {
      if (this.selectedProgramId != null) {
        try {
          let holidayPrograms = await this.restClient.getHolidayPrograms();

          let selectedProgram = holidayPrograms.find((item) => item.ID == this.selectedProgramId);
          if (selectedProgram !== undefined) {
            this.programDetails = selectedProgram;
          }

          this.selectPrice();

          this.selectDetailsMode(this.mode);
        } catch (e) {
          alert(e.message);
        }
      }
    }, */

    async loadProgramDetails() {
      if (this.selectedProgramId != null) {
        try {
          this.programDetailsWithBookings = await this.restClient.getHolidayProgramWithBookings(this.selectedProgramId);
          let { bookings, ...programDetails } = this.programDetailsWithBookings;
          this.programDetails = programDetails;

          this.selectPrice();

          this.selectDetailsMode(this.mode);
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadProgramBookingDetails() {
      if (this.selectedProgramId != null) {
        if (this.selectedBookingId != null) {
          try {
            let holidayProgramBooking = await this.restClient.getHolidayProgramBookingWithProgram(
              this.selectedProgramId,
              this.selectedBookingId
            );

            this.programBookingDetails = holidayProgramBooking.booking;

            if (this.programBookingDetails.sepaMandate != null) {
              this.useSepaMandate = true;
            }

            this.setCachedCustomerGuardian();
            this.setCachedCustomersBirthDates();
            this.selectPrice();
            this.setCachedPrices();

            //this.setCachedBirthDate()
          } catch (e) {
            alert(e.message);
          }
        } else {
          this.programBookingDetails = {
            ...defaultHolidayProgramBookingJson(),
          };

          this.setCachedCustomerGuardian();
          this.setCachedCustomersBirthDates();
        }
      }
    },

    getDefaultCustomer(): CustomerJson {
      return defaultCustomerJson();
    },

    getDefaultSepaMandate(): SepaMandateJson {
      //todo: if else notwendig?
      if (this.cachedCustomerGuardian != null) {
        return {
          ID: null,
          dateTime: new Date().toISOString(),
          lastUseDateTime: new Date().toISOString(),
          accountHolderFirstName: this.cachedCustomerGuardian.guardianFirstName,
          accountHolderLastName: this.cachedCustomerGuardian.guardianLastName,
          addressStreet: this.cachedCustomerGuardian.addressStreet,
          addressZip: this.cachedCustomerGuardian.addressZip,
          addressCity: this.cachedCustomerGuardian.addressCity,
          addressCountry: this.cachedCustomerGuardian.addressCountry,
          IBAN: "",
          BIC: "",
        };
      } else {
        return {
          ID: null,
          dateTime: new Date().toISOString(),
          lastUseDateTime: new Date().toISOString(),
          accountHolderFirstName: "",
          accountHolderLastName: "",
          addressStreet: "",
          addressZip: "",
          addressCity: "",
          addressCountry: "Deutschland",
          IBAN: "",
          BIC: "",
        };
      }
    },

    //START set cached data

    setCachedPrices() {
      if (this.programBookingDetails != null) {
        let k = this.cachedPrices;
        let i: keyof typeof k;

        for (i in this.cachedPrices) {
          if (this.programBookingDetails[i] == null) {
            this.cachedPrices[i] = "";
          } else {
            this.cachedPrices[i] = this.getFormatPrice(this.programBookingDetails[i]!);
          }
        }
      }
    },

    /* setCachedPrice() {
         if (this.programBookingDetails != null) {
            if (this.programBookingDetails.price == null) {
               this.cachedPrice = ""
            } else {
               this.cachedPrice = this.getFormatPrice(this.programBookingDetails.price)
            }
         }
      }, */

    setCachedCustomerGuardian() {
      if (this.programBookingDetails != null && this.programBookingDetails.customers.length > 0) {
        this.cachedCustomerGuardian.guardianFirstName = this.programBookingDetails.customers[0].guardianFirstName;
        this.cachedCustomerGuardian.guardianLastName = this.programBookingDetails.customers[0].guardianLastName;
        this.cachedCustomerGuardian.email = this.programBookingDetails.customers[0].email;
        this.cachedCustomerGuardian.phone = this.programBookingDetails.customers[0].phone;
        this.cachedCustomerGuardian.addressStreet = this.programBookingDetails.customers[0].addressStreet;
        this.cachedCustomerGuardian.addressZip = this.programBookingDetails.customers[0].addressZip;
        this.cachedCustomerGuardian.addressCity = this.programBookingDetails.customers[0].addressCity;
        this.cachedCustomerGuardian.addressCountry = this.programBookingDetails.customers[0].addressCountry;
      }
    },

    setCachedCustomersBirthDates() {
      if (this.programBookingDetails != null && this.programBookingDetails.customers.length > 0) {
        for (let i = 0; i < this.programBookingDetails.customers.length; i++) {
          if (this.programBookingDetails.customers[i].childBirthDate != "") {
            if (this.supportsDatePicker) {
              this.cachedCustomersBirthDates[i] = this.programBookingDetails.customers[i].childBirthDate!;
            } else {
              let d = new Date(this.programBookingDetails.customers[i].childBirthDate!);

              if (d != null) {
                this.cachedCustomersBirthDates[i] = DateFormatter.formatDateMedium(d);
              }
            }
          }
        }
      }
    },

    //END set cached data

    async reloadDetailsView() {
      if (this.selectedProgramId != null && this.selectedBookingId != null) {
        this.programBookingDetails = null;
        try {
          let holidayProgramBooking = await this.restClient.getHolidayProgramBookingWithProgram(
            this.selectedProgramId,
            this.selectedBookingId
          );

          this.programBookingDetails = holidayProgramBooking.booking;

          if (this.programBookingDetails.sepaMandate != null) {
            this.useSepaMandate = true;
          }

          this.setCachedCustomerGuardian();

          this.$nextTick(() => {
            this.hasChanges = false;
          });
        } catch (e) {
          alert(e.message);
        }
      } else {
        this.closeDetails();
      }
    },

    selectDetailsMode(mode: string) {
      this.resetHintChanged();

      switch (mode) {
        case "add":
          this.detailsMode = "add";
          this.detailsTitle = "Buchung hinzufügen";
          this.editable = true;
          break;

        case "edit":
          this.detailsMode = "edit";
          this.detailsTitle = "Buchung bearbeiten";
          this.editable = true;
          break;

        default:
          this.detailsMode = "read";
          this.detailsTitle = "Buchung für " + this.programDetails?.title;
          this.editable = false;
          break;
      }
    },

    toggleEditMode() {
      this.editable = !this.editable;
    },

    resetHintChanged() {
      let k = this.hintChanged;
      let i: keyof typeof k;

      for (i in this.hintChanged) {
        this.hintChanged[i] = false;
      }
    },

    stopEditMode() {
      if (!this.hasChanges) {
        this.selectDetailsMode("show");
        this.reloadDetailsView();
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          this.selectDetailsMode("show");
          this.reloadDetailsView();
        } else {
          //do nothing
        }
      }
    },

    closeDetails() {
      if (!this.hasChanges) {
        this.$emit("closeOverlay");
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          this.$emit("closeOverlay");
        } else {
          //do nothing
        }
      }
    },

    inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      if (this.programBookingDetails != null) {
        this.validation = validateHolidayProgramBookingJson(this.programBookingDetails);
      }

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    /* START frontend validation */

    frontendValidation() {
      this.validateAge();
      this.validateAllGuardiansEmployed();
      this.validateRequiredEmployerInputs();
      this.validateChildrenGradeLevel();
    },

    validateAge() {
      if (
        this.programDetails != null &&
        this.programBookingDetails != null &&
        this.programBookingDetails.customers != null
      ) {
        this.frontendValidations.minimumAge = false;
        this.frontendValidations.maximumAge = false;

        let beginDate = this.programDetails.beginDate;

        for (let c of this.programBookingDetails.customers) {
          if (c.childBirthDate) {
            let testDate = new Date(beginDate);
            let birthDate = new Date(c.childBirthDate);

            let age = testDate.getFullYear() - birthDate.getFullYear();
            let month = testDate.getMonth() - birthDate.getMonth();
            if (month < 0 || (month === 0 && testDate.getDate() < birthDate.getDate())) {
              age--;
            }

            if (this.programDetails.restrictMinimumAge != null && age < this.programDetails.restrictMinimumAge) {
              this.frontendValidations.minimumAge = true;
            }

            if (this.programDetails.restrictMaximumAge != null && age > this.programDetails.restrictMaximumAge) {
              this.frontendValidations.maximumAge = true;
            }
          }
        }
      }
    },

    validateAllGuardiansEmployed() {
      if (this.programBookingDetails != null && this.selectedPrice != null) {
        this.frontendValidations.requiresAllGuardiansEmployed = false;
        this.frontendValidations.neededIsSingleParent = false;

        if (this.selectedPrice.requiresAllGuardiansEmployed) {
          this.frontendValidations.requiresAllGuardiansEmployed = true;

          if (this.programBookingDetails.isSingleParent == null) {
            this.frontendValidations.neededIsSingleParent = true;
          } else {
            if (this.programBookingDetails.isSingleParent && this.programBookingDetails.isWorking) {
              this.frontendValidations.requiresAllGuardiansEmployed = false;
            }

            if (
              this.programBookingDetails.isSingleParent == false &&
              this.programBookingDetails.isWorking &&
              this.programBookingDetails.isPartnerWorking
            ) {
              this.frontendValidations.requiresAllGuardiansEmployed = false;
            }
          }
        }
      }
    },

    validateRequiredEmployerInputs() {
      this.frontendValidations.requiresEmployerInputs = false;

      if (this.showEmployerInputs && this.programBookingDetails != null) {
        if (this.selectedPrice && this.selectedPrice.showEmployerInputs) {
          if (this.programBookingDetails.isWorking && this.programBookingDetails.employerFirst == "") {
            this.frontendValidations.requiresEmployerInputs = true;
          } else if (this.programBookingDetails.isPartnerWorking && this.programBookingDetails.employerSecond == "") {
            this.frontendValidations.requiresEmployerInputs = true;
          }
        }
      }
    },

    validateChildrenGradeLevel() {
      if (
        this.selectedPrice != null &&
        this.programBookingDetails != null &&
        this.programBookingDetails.customers != null
      ) {
        this.frontendValidations.minimumClass = false;
        this.frontendValidations.maximumClass = false;

        const minClass = this.selectedPrice.childrenClassMinimum;
        const maxClass = this.selectedPrice.childrenClassMaximum;

        for (let c of this.programBookingDetails.customers) {
          if (c.childGradeLevel) {
            if (minClass != null && minClass > c.childGradeLevel) {
              this.frontendValidations.minimumClass = true;
            }

            if (maxClass != null && maxClass < c.childGradeLevel) {
              this.frontendValidations.maximumClass = true;
            }
          }
        }
      }
    },

    /* END frontend validation */

    selectPrice() {
      if (this.programDetails != null && this.programBookingDetails != null) {
        let selectedPrice = this.programDetails.discountPrices.find(
          (i: HolidayProgramPriceJson) => i.title == this.programBookingDetails?.selectedDiscount
        );

        if (selectedPrice) {
          this.selectedPrice = selectedPrice;
        } else {
          this.selectedPrice = null;
        }

        this.checkShowEmployerInputs();
      }
    },

    //START set input data (where data be cached)

    formatAndSetCachedPrices(key: keyof keysForCachedPrices) {
      if (this.programBookingDetails != null) {
        let price = this.cachedPrices[key].replace(".", ",");

        if (!price.includes(",")) {
          price += ",00";
        }

        if (!price.match(/^\d{1,}(,\d{2})?$/)) {
          price = "";
        }

        this.cachedPrices[key] = price;
        this.programBookingDetails[key] = parseInt(price.replace(/[\D]/g, ""));
      }
    },

    /* setPrice() {
         if (this.programBookingDetails != null) {
            let price = this.cachedPrice.replace(".", ",")

            if (!price.includes(",")) {
               price += ",00"
            }

            if (!price.match(/^\d{1,}(,\d{2})?$/)) {
               price = ""
            }

            this.cachedPrice = price
            this.programBookingDetails.price = parseInt(price.replace(/[\D]/g, ""))
         }
      }, */

    setCustomersBirthDates(customer: number) {
      if (this.programBookingDetails != null && this.programBookingDetails.customers != null) {
        var birthDate = "";

        if (this.supportsDatePicker) {
          birthDate = this.cachedCustomersBirthDates[customer];
        } else {
          if (this.cachedCustomersBirthDates[customer].match(/^\d{1,2}.\d{1,2}.\d{4}$/g)) {
            let d = DateFormatter.parseDateString(this.cachedCustomersBirthDates[customer]);

            if (d != null) {
              birthDate = DateFormatter.formatISODate(d);
            }
          }
        }

        this.programBookingDetails.customers[customer].childBirthDate = birthDate;
      }
    },

    //END set input data (where data be cached)

    addCustomer() {
      if (this.programBookingDetails != null) {
        this.programBookingDetails.customers.push(this.getDefaultCustomer());
      }
    },

    deleteCustomer(index: number) {
      if (this.programBookingDetails != null && this.programBookingDetails.customers != null) {
        if (this.programBookingDetails.customers.length > 1) {
          this.programBookingDetails.customers.splice(index, 1);
          this.cachedCustomersBirthDates.splice(index, 1);

          delete this.toValidate["customer-" + index];
        } else {
          alert("Es muss mindestens ein Kind angemeldet werden.");
        }
      }
    },

    checkShowEmployerInputs() {
      if (this.selectedPrice && this.selectedPrice.showEmployerInputs) {
        this.showEmployerInputs = true;
        return true;
      } else {
        if (this.programBookingDetails) {
          this.programBookingDetails.employerFirst = "";
          this.programBookingDetails.employerSecond = "";
        }

        this.showEmployerInputs = false;
        return false;
      }
    },

    toggleUseSepaMandate() {
      if (this.programBookingDetails != null) {
        if (this.useSepaMandate) {
          this.programBookingDetails.sepaMandate = null;
          this.useSepaMandate = false;
        } else {
          this.programBookingDetails.sepaMandate = this.getDefaultSepaMandate();
          this.useSepaMandate = true;
        }
      }
    },

    async saveProgramBookingDetails() {
      if (this.programBookingDetails != null && this.selectedProgramId) {
        if (this.hasChanges) {
          this.loadingGeneral = true;

          //update guardian info at all customers (from cachedCustomerGuardian)
          this.addCustomerGuardian();

          //todo ###START
          //todo: Validation muss durchgeführt werden (siehe hier) ->AUCH bei SettingsDetails
          this.validation = validateHolidayProgramBookingJson(this.programBookingDetails);
          //todo ###END

          this.submitValidation = true;

          if (this.validation != null && this.validation.isValid == true) {
            if (this.restClient != null) {
              try {
                let updatedBookingDetails = await this.restClient.updateHolidayProgramBooking(
                  this.selectedProgramId,
                  this.programBookingDetails
                );

                alert("Die Änderungen wurden erfolgreich gespeichert.");

                this.$nextTick(() => {
                  this.hasChanges = false;
                  this.loadingGeneral = false;
                  this.stopEditMode();
                });
              } catch (e) {
                this.loadingGeneral = false;
                alert(e.message);
              }
            }
          } else {
            this.loadingGeneral = false;
            alert("Die Änderungen konnten nicht gespeichert werden. Bitte überprüfen Sie Ihre Änderungen.");
          }
        } else {
          alert("Es wurden keine Änderungen vorgenommen.");
        }
      }
    },

    async addNewProgramBooking() {
      if (this.programBookingDetails != null && this.selectedProgramId != null) {
        this.loadingGeneral = true;

        this.addCancellationInfo();
        //add guardian info to all customers (from cachedCustomerGuardian)
        this.addCustomerGuardian();

        this.validation = validateHolidayProgramBookingJsonAddNew(this.programBookingDetails);

        this.submitValidation = true;

        if (this.validation != null && this.validation.isValid == true) {
          try {
            this.programBookingDetails = await this.restClient.addHolidayProgramBooking(
              this.selectedProgramId,
              this.programBookingDetails
            );
            alert("Die Buchung wurde erfolgreich hinzugefügt.");
            this.$nextTick(() => {
              this.hasChanges = false;
              this.loadingGeneral = false;
              this.stopEditMode();
            });
          } catch (e) {
            this.loadingGeneral = false;
            alert(e.message);
          }
        } else {
          this.loadingGeneral = false;
          //todo Validation Error anzeigen
          alert("Die Buchung konnte nicht hinzugefügt werden. Bitte überprüfen Sie Ihre Angaben.");
        }
      }
    },

    async deleteProgramBooking() {
      if (this.selectedProgramId != null && this.selectedBookingId != null) {
        let c = confirm("Wollen Sie diese Buchung wirklich unwiderruflich löschen?");
        if (c == true) {
          if (this.restClient != null) {
            try {
              await this.restClient.deleteHolidayProgramBooking(this.selectedProgramId, this.selectedBookingId);
              this.closeDetails();
              alert("Die Buchung wurde erfolgreich gelöscht.");
            } catch (e) {
              alert(e.message);
            }
          }
        } else {
          //do nothing
        }
      }
    },

    async sendBookingConfirmation() {
      this.loadingNextup = true;

      if (this.hasChanges) {
        await this.saveProgramBookingDetails();
      }

      if (this.programBookingDetails != null && this.selectedProgramId != null && this.restClient != null) {
        try {
          await this.restClient.confirmHolidayProgramBooking(this.selectedProgramId, this.programBookingDetails);
          alert("Es wurde eine Bestätigung an den Kunden gesendet.");
          this.hasChanges = false;
          this.stopEditMode();
          this.loadingNextup = false;
        } catch (e) {
          alert(e.message);
          this.loadingNextup = false;
        }
      }
    },

    async cancelHolidayBooking() {
      if (!this.hasChanges) {
        if (this.programBookingDetails != null && this.selectedProgramId != null) {
          let c = confirm(
            "Wollen Sie die Absage per E-Mail bestätigen? Die Buchung wird unter Berücksichtigung der Stornierungsgebühr (€ " +
              this.getFormatPrice(this.programBookingDetails.cancellationFee) +
              ") abgesagt."
          );
          if (c == true) {
            this.loadingGeneral = true;

            if (this.restClient != null) {
              try {
                await this.restClient.cancelHolidayProgramBooking(this.selectedProgramId, this.programBookingDetails);
                this.closeDetails();
                alert("Die Buchung wurde erfolgreich abgesagt.");

                this.loadingGeneral = false;
              } catch (e) {
                alert(e.message);

                this.loadingGeneral = false;
              }
            }
          } else {
            //do nothing
          }
        }
      } else {
        alert("Bitte speichern Sie zuvor die letzten Änderungen.");
      }
    },

    addCancellationInfo() {
      if (this.programBookingDetails != null && this.programDetails != null) {
        if (this.selectedPrice == null) {
          this.programBookingDetails.cancellationFee = this.programDetails.basePrice.cancellationFee;
          this.programBookingDetails.cancellationRemarks = this.programDetails.basePrice.cancellationRemarks;
        } else {
          this.programBookingDetails.cancellationFee = this.selectedPrice.cancellationFee;
          this.programBookingDetails.cancellationRemarks = this.selectedPrice.cancellationRemarks;
        }
      }
    },

    addCustomerGuardian() {
      if (this.programBookingDetails != null && this.programBookingDetails.customers != null) {
        for (let i = 0; i < this.programBookingDetails.customers.length; i++) {
          this.programBookingDetails.customers[i].guardianFirstName = this.cachedCustomerGuardian.guardianFirstName;
          this.programBookingDetails.customers[i].guardianLastName = this.cachedCustomerGuardian.guardianLastName;
          this.programBookingDetails.customers[i].email = this.cachedCustomerGuardian.email;
          this.programBookingDetails.customers[i].phone = this.cachedCustomerGuardian.phone;
          this.programBookingDetails.customers[i].addressStreet = this.cachedCustomerGuardian.addressStreet;
          this.programBookingDetails.customers[i].addressZip = this.cachedCustomerGuardian.addressZip;
          this.programBookingDetails.customers[i].addressCity = this.cachedCustomerGuardian.addressCity;
          this.programBookingDetails.customers[i].addressCountry = this.cachedCustomerGuardian.addressCountry;
        }
      }
    },

    // print
    printBookingDetails() {
      var toPrint = document.getElementById("toPrint");

      if (toPrint != null) {
        var eles = this.$el.querySelectorAll(".print-view");

        for (let i = 0; i < eles.length; i++) {
          toPrint.appendChild(eles[i].cloneNode(true));
        }
      }

      this.$nextTick(() => {
        window.print();
      });

      this.$nextTick(() => {
        while (toPrint?.lastElementChild) {
          toPrint.removeChild(toPrint.lastElementChild);
        }
      });
    },

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },

  watch: {
    programBookingDetails: {
      handler(val, oldVal) {
        if (oldVal != null) {
          this.hasChanges = true;
        }
      },
      deep: true,
    },
  },

  computed: {
    permissionAble: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    holidayProgramRegistrationsLeftText(): string {
      if (this.programDetailsWithBookings != null) {
        let registrationCount = 0;

        for (let booking of this.programDetailsWithBookings.bookings) {
          if (
            booking.state != "pending" &&
            booking.state != "canceled" &&
            booking.state != "cancellationFeeExported" &&
            booking.state != "waitingList"
          ) {
            registrationCount += booking.customers.length;
          }
        }

        let registrationsLeft = this.programDetailsWithBookings.registrationMaximumCount - registrationCount;

        if (registrationsLeft < 0) {
          return "Bereits überbucht";
        } else if (registrationsLeft == 1) {
          return "Noch 1 freier Platz";
        } else {
          return "Noch " + registrationsLeft + " freie Plätze";
        }
      }

      return "Lade freie Plätze...";
    },

    /* formatPrice: {
         get(): string | undefined {
            if (this.programBookingDetails != null) {
               if (this.programBookingDetails.price != null) {
                  let price =
                     "€ " +
                     this.programBookingDetails.price
                        .toString()
                        .padStart(3, "0")
                        .replace(/(\d{2,2})$/g, ",$1")
                        .replace("NaN", "")
                  return price
               }
            }
         },
         set(value: string) {
            if (this.programBookingDetails != null) {
               this.programBookingDetails.price = parseInt(value.replace(/[\D]/g, ""))
            }
         }
      }, */

    formatIBAN: {
      get(): string | undefined {
        if (this.programBookingDetails != null) {
          if (this.programBookingDetails.sepaMandate != null) {
            return this.programBookingDetails.sepaMandate.IBAN.toUpperCase()
              .replace(/[^0-9A-Z]/g, "")
              .replace(/(.{1,4})/g, "$1 ")
              .trim();
          }
        }
      },
      set(value: string) {
        if (this.programBookingDetails != null) {
          if (this.programBookingDetails.sepaMandate != null) {
            this.programBookingDetails.sepaMandate.IBAN = value;
          }
        }
      },
    },
  },
});
